import { render, staticRenderFns } from "./StatementEdit.vue?vue&type=template&id=595e61ba&scoped=true&"
import script from "./StatementEdit.vue?vue&type=script&lang=js&"
export * from "./StatementEdit.vue?vue&type=script&lang=js&"
import style0 from "./StatementEdit.vue?vue&type=style&index=0&id=595e61ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595e61ba",
  null
  
)

export default component.exports